import { TokenRow } from '../types';
import { FC } from 'react';
import DateCell from './DateCell';

type Props = TokenRow;

const PairedAtCell: FC<Props> = ({ pairedAt }) => <DateCell date={pairedAt} />;

export default PairedAtCell;
